import React, { useEffect, useState, useRef } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Util } from "reactstrap";
import "./Card.scss";
import '../Icons/IconFontawesome';
import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import 'react-vertical-timeline-component/style.min.css';
import HTMLRenderer from 'react-html-renderer';
import { AvForm, AvField } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
import DataTable from 'react-data-table-component';
import DeleteModal from "./DeleteModal";
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import { CSVLink } from "react-csv";

const LeadSingle = (props) => {
  const { user, opporId, currentUser } = props;
  const [data, setData] = useState({ company: [{}], quali: [{}], course: [{}], industry: [{}] });
  const [isCredForm, setIsCredForm] = useState(false);
  const [columns, setColumns] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const activeTillRef = useRef(null);
  const [appColumn, setAppColumn] = useState([]);
  let csvHeader = ["Name", "Email", "Mobile", "Father's Name", "Mother's Name", "Adhaar No.", "Pan No.", "Guardian Mobile No.",
    "Guardian Relational", "Guardian Name", "Date of Birth", "Pin Code", "City", "State", "Address", "Landmark Address", "Category",
    "Gender", "Education", "Experience", "AC holder name", "Bank Name", "Bank A/C No.", "IFSC Code"
  ];
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    console.log('oppor id on single oppor', opporId);
    if (user && opporId) {
      getOppor();
    }
  }, [user, opporId]);

  const getOppor = async () => {
    get("/oppor/detail?opporId=" + opporId, { token: user?.token })
      .then(json => {
        console.log('response from get oppor single', json);
        if (json?.statusCode == 200) {
          if (json?.data?.duration) {
            json.data.durationType = json?.data?.duration.split(" ")[1];
            json.data.duration = json?.data?.duration.split(" ")[0];
          }
          if (json?.data?.activeTill)
            json.data.activeTill = json?.data?.activeTill.split("T")[0];
          setData(json?.data);
          let csvData = [];
          json?.data?.applicant?.map((item, index) => {
            let educat = "", exper = "";
            item.data[0]?.education?.map((edu) => {
              educat = educat + edu?.type + " " + edu?.year + " " + edu?.mark + "/" + edu?.totalMark + " " + edu?.program + " " + edu?.collage + "\n"
            });
            item?.data[0]?.experience?.map((exp) => {
              exper = exper + exp?.role + " " + exp?.start + "-" + exp?.end + " " + exp?.companyName + " (" + exp?.location + ")\n"
            })
            csvData.push([
              item?.data[0]?.name,
              item?.data[0]?.email,
              item?.data[0]?.mobile,
              item?.data[0]?.fName,
              item?.data[0]?.mName,
              item?.data[0]?.adharNo,
              item?.data[0]?.panNo,
              item?.data[0]?.mobileR,
              item?.data[0]?.relativeRelation,
              item?.data[0]?.relativeName,
              item?.data[0]?.dob,
              item?.data[0]?.pincode,
              item?.data[0]?.city,
              item?.data[0]?.state,
              item?.data[0]?.address,
              item?.data[0]?.landmark,
              item?.data[0]?.cast,
              item?.data[0]?.gender,
              educat,
              exper,
              item?.data[0]?.bankHolderName,
              item?.data[0]?.bankName,
              item?.data[0]?.accountNo,
              item?.data[0]?.ifscCode,
            ]);
          });
          setCsvData(csvData);
          setColumns([
            {
              name: 'Name',
              selector: row => row.name,
            },
            {
              name: 'Email',
              selector: row => row.email,
            },
            {
              name: 'Created At',
              selector: row => row.createdAt,
            },
            {
              cell: (row) => <>
                <Button onClick={() => handleDeleteCred(row)}
                  title={"Ban"}
                  style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button>
              </>,
              name: 'Action',
              ignoreRowClick: true,
            },
          ]);
          setAppColumn([
            {
              name: 'Name',
              selector: row => row?.data[0]?.name,
            },
            {
              name: 'Email',
              selector: row => row?.data[0]?.email,
            },
            {
              name: 'Created At',
              selector: row => row.createdAt,
            },
            {
              cell: (row) => <>
                <Button onClick={() => handleDeleteCred(row)}
                  title={"Ban"}
                  style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button>
              </>,
              name: 'Action',
              ignoreRowClick: true,
            },
          ]);
        }
      })
      .catch(error => {
        console.log('error while getting lead detail', error);
      })
  }

  const handleActiveTill = (e, values) => {
    console.log('values', typeof values, values);
    const body = {
      opporId: data?._id,
      activeTill: new Date(values),
      token: user?.token,
    };
    let url = "/oppor/update";
    put(url, body)
      .then((json) => {
        console.log('response from updating user', json);
        if (json.statusCode == 200) {
          console.log('oppor added')
          toast.success(json?.message);
          getOppor();
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        console.error('error while adding oppor', error);
        toast.error(JSON.stringify(error));
      });
  }

  const handleDeleteCred = (row) => {
    console.log('banning user from oppor', opporId, 'user id', row?.userId);
    let body = {
      opporId: opporId,
      userId: row?.userId,
      token: user?.token
    }
    post('/oppor/ban', body)
      .then(res => {
        console.log('response from ban', res);
        if (res?.statusCode == 200) {
          toast.success('User Banned.');
          getOppor();
        } else {
          toast.error(res?.error);
        }
      })
  }

  const handleUpdateStatus = () => {
    props?.setCurrentUser({ ...data, actionType: 'Status' });
    setDeleteModal(true);
  }

  const onStatus = (type) => {
    let body = {
      opporId: data?._id,
      isActive: !data?.isActive,
      isActiveType: null,
      token: user?.token
    }
    if (type) {
      body = { ...body, isActiveType: type }
    }
    put('/oppor/update', body)
      .then(json => {
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getOppor();
          setDeleteModal(false);
        }
      })
      .catch(error => {
        console.log('error while updating status', error);
        toast.error('Something Went Wrong!');
      })
  }

  const shareUrl = () => {
    let title = data?.title.toLowerCase();
    let path = title.split(" ").join("_") + "_" + data?._id;
    console.log('path', path);
    navigator.clipboard.writeText('http://192.168.0.131:3000/opportunity/' + path);
    toast.success('Copied to clipboard!');
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={(type) => onStatus(type)}
          onCloseClick={() => setDeleteModal(false)}
          data={currentUser}
          actionType={currentUser?.actionType}
        />
        <Row>
          <Col xl={12}>
            <Row className="d-flex justify-content-between">
              <Col md={6}>
                <Row>
                  <Col md={6}>
                    <span style={{ color: 'black', fontWeight: 'bold', fontSize: 20 }}>{data?.title} <span style={{ fontSize: 16, color: 'gray', fontWeight: 'normal', textTransform: 'capitalize' }}>({data?.createdAt})</span>
                    </span>
                    <p>Active Till :-
                      {/* {data?.activeTill} */}
                      <DatePicker selected={data?.activeTill ? new Date(data?.activeTill) : new Date()} onChange={(date) => handleActiveTill(null, date)} ref={activeTillRef}
                        className="border calpicker"
                        dateFormat="yyyy/MM/dd"
                      />
                      <i className="mdi mdi-pencil" onClick={() => { console.log(activeTillRef?.current); activeTillRef?.current?.deferFocusInput() }}></i>
                    </p>
                  </Col>
                </Row>
              </Col>
              <Col md={6} className="d-flex justify-content-end align-items-center">
                <div style={{ textAlignLast: 'right', marginRight: 10 }}>
                  <Button onClick={() => handleUpdateStatus()}
                    title={data?.isActive ? "Inactive" : "Active"}
                    style={{ backgroundColor: !data.isActive ? 'red' : 'green', padding: 8, paddingLeft: 8, paddingRight: 8 }}>
                    <span className="text-white" style={{}}>
                      {!data?.isActive ? `Inactive ${data?.isActiveType ? ` for ${data?.isActiveType}` : ''}` : 'Active'}
                    </span>
                  </Button>
                </div>
                <div style={{ textAlignLast: 'right', marginRight: 10 }}>
                  <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => shareUrl()}>
                    Share
                  </Button>
                </div>
                <div style={{ textAlignLast: 'right', marginRight: 10 }}>
                  <Button style={{ backgroundColor: Utils.themeColor }}>
                    <a href="#applicants" style={{ color: 'white' }}>
                      Applicants ({data?.applicant?.length})
                    </a>
                  </Button>
                </div>
                <div style={{ textAlignLast: 'right', marginRight: 10 }}>
                  <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => { props?.setCurrentUser({ ...data, _id: undefined, companyId: undefined }); props?.add(true) }}>
                    Duplicate
                  </Button>
                </div>
                <div style={{ textAlignLast: 'right', marginRight: 10 }}>
                  <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => { props?.setCurrentUser(data); props?.add(true) }}>
                    Update
                  </Button>
                </div>
                <div style={{ textAlignLast: 'right' }}>
                  <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => props?.history.replace("/opportunities")}>
                    Back
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Card className="p-3">
              <CardTitle><h5>Locations</h5></CardTitle>
              {/* <CardBody> */}
              <div className="d-flex">
                {data?.location?.map((item) => {
                  return (
                    <div className="d-flex me-2">
                      <i className="mdi mdi-map-marker-outline" />
                      <span className="me-1">{item?.city},</span>
                      <span className="me-1">{item?.state}</span>
                    </div>
                  )
                })}
              </div>
              {/* </CardBody> */}
            </Card>
            <Card className="p-3">
              <CardTitle><h5>Description</h5></CardTitle>
              <div className="d-flex">
                <HTMLRenderer
                  html={data?.desc}
                />
              </div>
            </Card>
            <Card className="p-3">
              <CardTitle><h5>Company Details</h5></CardTitle>
              <Row className="justify-content-around">
                <Col md={3}>
                  <p className="m-0"><b>Name : </b>{data?.company[0]?.title}</p>
                  <p className="m-0"><b>Code : </b>{data?.company[0]?.code}</p>
                </Col>
                <Col md={3}>
                  <p className="m-0"><b>Strength : </b>{data?.company[0]?.strength}</p>
                  <p className="m-0"><b>Type : </b>{data?.company[0]?.type}</p>
                </Col>
                <Col md={3}>
                  <p className="m-0"><b>Operating states : </b>{data?.company[0]?.operatingState}</p>
                  <p className="m-0"><b>Working Day : </b>{data?.company[0]?.workingDay}</p>
                </Col>
              </Row>
            </Card>
            {/* Qualification */}
            <Card className="p-3">
              <CardTitle><h5>Qualification Required</h5></CardTitle>
              <div className="d-flex justify-content-around">
                <span className="me-1"><b>Minimum Qualification : </b>{data?.quali[0]?.title}</span>
              </div>
            </Card>
            {/* Course Details */}
            <Card className="p-3">
              <CardTitle><h5>Course Details</h5></CardTitle>
              <Row className="justify-content-around">
                <Col md={3}>
                  <p className="m-0"><b>Course Name: </b>{data?.course[0]?.title}</p>
                  <p className="m-0"><b>Is NAPS: </b>{data?.course[0]?.isNAPS ? "Yes" : "No"}</p>
                </Col>
                <Col md={3}>
                  <p className="m-0"><b>Industry: </b>{data?.industry[0]?.title}</p>
                  <p className="m-0"><b>Duration: </b>{data?.duration} {data?.durationType}</p>
                </Col>
              </Row>
            </Card>
            <Card className="p-3">
              <CardTitle>
                <div className="d-flex justify-content-between">
                  <h5>Access Credentials</h5>
                  {/* <div style={{ textAlignLast: 'right' }}>
                    <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => { setIsCredForm(true); }}>
                      +Add
                    </Button>
                  </div> */}
                </div>
              </CardTitle>
              <DataTable
                columns={columns}
                data={data.manager}
                pagination
                customStyles={{
                  headCells: {
                    style: {
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: 15,
                      maxWidth: 80
                    },
                  },
                  cells: {
                    style: {
                      maxWidth: 50
                    }
                  }
                }}
              />
            </Card>
            <Card className="p-3" id="applicants">
              <CardTitle>
                <div className="d-flex justify-content-between">
                  <h5>Applicants</h5>
                  <div style={{ textAlignLast: 'right' }}>
                    <CSVLink
                      data={csvData}
                      headers={csvHeader}
                      // ref={(r) => (reportButton = r)}
                      filename={`Applicant_${new Date().getTime()}.csv`}
                      target="_blank"
                    >
                      <Button style={{ backgroundColor: Utils.themeColor }}>
                        Download CSV
                      </Button>
                    </CSVLink>
                  </div>
                </div>
              </CardTitle>
              <DataTable
                columns={appColumn}
                data={data?.applicant}
                pagination
                customStyles={{
                  headCells: {
                    style: {
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: 15,
                      maxWidth: 80
                    },
                  },
                  cells: {
                    style: {
                      maxWidth: 50
                    }
                  }
                }}
              />
            </Card>
          </Col>
        </Row>
      </Row>
    </React.Fragment>
  )
}

export default LeadSingle;
